(ns story-builder.story-list.sidebar.util
  (:require
   [story-builder.util.core :as util]
   [story-builder.util.js :as util.js]))

(defn generate-tag-code
  [{:keys [ad-tag?
           config]}]
  (let [{:keys [width
                height]} config]
    (if ad-tag?
      (str "<script>"
           "window.NWS = " (-> config clj->js util.js/stringify-js-object) ";"
           "</script>"
           "<script src='https://assets-cf1.nws.ai/js/in-feed-1.8.js'></script>")
      ;; Default case: Render an iframe
      (str "<iframe src=\"" (:storyURL config)
           "?opts=fb:1\" frameborder=\"0\" scrolling=\"no\" "
           "style=\"width:" width ";height:" height ";position:relative;"
           "margin:0 auto;display:block;\"></iframe>"))))

(defn generate-tag-config
  [config]
  (let [{:keys [type
                slug
                story
                url
                story-config
                website-alias
                website-id
                info-url
                force-url?
                variants?
                frame-type
                width
                height]
         :or {force-url? false}} config
        story-config     (util/read-config story-config)
        scroll-tracking? (let [scroll-vec   [:parent-page-data :window :scroll :percentages :main-percent]
                               check-nested (fn check-nested [config]
                                              (cond
                                                (= config scroll-vec) true
                                                (map? config) (some #(check-nested (val %)) config)
                                                (sequential? config) (some check-nested config)
                                                :else false))]
                           (check-nested story-config))
        base-config     (util/filter-nil
                         (merge {:siteAlias   website-alias
                                 :creativeId  slug
                                 :websiteId   website-id
                                 :publisherId (:publisher story)
                                 :storyId     (:int-id story)
                                 :authorId    (-> story :user :id)
                                 :storyURL    (if (or force-url? (= type :iframe))
                                                (str "https:" url)
                                                (str "https://stories.nws.ai/" (or website-alias website-id)
                                                     "/" slug
                                                     "/" (when variants? "?variant=ctr")))
                                 :infoURL     info-url
                                 :footer      false}
                                (when scroll-tracking?
                                  {:scrollTracking true
                                   :experience     "sticky-full-height"
                                   :fixedHeight    "300"})))
        platform-config (case type
                          :adform
                          {:bid          {:appID     "__ADFAPPID__"
                                          :sourceURL "__ADFREFERER__"
                                          :platform  "adform"}
                           :clickActions ["action" "link_click_out"]
                           :clickURL     "%%c1;cpdir="}
                          :gam
                          {:bid          {:sourceURL "%%SITE%%"
                                          :platform  "gam"}
                           :clickActions ["action" "link_click_out"]
                           :clickType    "img"
                           :clickURL     "%%CLICK_URL_UNESC%%"}
                          :dv360
                          {:bid          {:appID     "${BUNDLE_ID}"
                                          :sourceURL "${SOURCE_URL}"
                                          :dealID    "${INVENTORY_SOURCE_EXTERNAL_ID}"
                                          :platform  "dv360"}
                           :clickActions ["action" "link_click_out"]
                           :clickURL     "${CLICK_URL}"}
                          :xandr
                          {:bid          {:appID     "${EXT_APP_ID}"
                                          :sourceURL "${REFERER_URL_ENC}"
                                          :price     "${PRICE_PAID}"
                                          :dealID    "${DEAL_ID}"
                                          :platform  "xandr"}
                           :clickActions ["action" "link_click_out"]
                           :clickURL     "${CLICK_URL}"}
                          :yahoo
                          {:clickActions ["action" "link_click_out"]
                           :clickURL     "${CLICKURL}"}
                          :ttd
                          {:clickActions ["action" "link_click_out"]
                           :clickURL     "%%TTD_CLK%%"}
                          :eskimi
                          {:bid          {:appID     "{app_bundle}"
                                          :sourceURL "{site_domain}"
                                          :platform  "eskimi"}
                           :clickActions ["action" "link_click_out"]
                           :clickURL     "{click_url}"}
                          :adkernel-rtb
                          {:bid          {:appID     "{app_bundle}"
                                          :sourceURL "{referrer}"
                                          :price     "{bid}"
                                          :platform  "adkernel-rtb"}
                           :clickActions ["action" "link_click_out"]
                           :clickURL     "{click_url_redir}"}
                          :adkernel-dsp
                          {:bid          {:appID     "{%app_bundle%}"
                                          :sourceURL "{%referrer%}"
                                          :price     "{%bid%}"
                                          :platform  "adkernel-dsp"}
                           :clickActions ["action" "link_click_out"]
                           :clickURL     "{%click_url_redir%}"}
                          :equativ
                          {:bid          {:appID     "{APP_BUNDLE}"
                                          :sourceURL "{SITE_DOMAIN}"
                                          :platform  "equativ"}
                           :clickActions ["action" "link_click_out"]
                           :clickURL     "{click_through}"}
                          ;; Default case (e.g. iframe)
                          nil)
        hostile-config  (when (= frame-type :hostile)
                          {:frameType "hostile"
                           :width     (str width "px")
                           :height    (str height "px")
                           :unit      {:size [width height]}})
        full-config     (merge base-config platform-config hostile-config)]
    full-config))

(defn embed-code
  [type story {:keys [frame-type
                      size
                      config-only?
                      force-url?]
               :or   {force-url? false}}]
  (let [{:keys [slug
                story-config
                url
                website]}      story
        {:keys         [meta]
         website-alias :alias} website
        [width height]         size
        info-url               (-> meta :tag :info-url)
        variants?              (-> story :data-source :entries seq boolean)
        tag-config             (generate-tag-config {:type          type
                                                     :slug          slug
                                                     :url           url
                                                     :story         story
                                                     :story-config  story-config
                                                     :website-id    (:website-id story)
                                                     :website-alias website-alias
                                                     :info-url      info-url
                                                     :force-url?    force-url?
                                                     :variants?     variants?
                                                     :frame-type    frame-type
                                                     :width         width
                                                     :height        height})]
    (if config-only?
      tag-config
      (generate-tag-code {:ad-tag? (not= type :iframe)
                          :config  tag-config}))))